import type { CountryIso2 } from '@/core/international'
import type { Uuid } from '@/core/shared'

export interface Location {
  id: string
  name: string
  address?: string
  energyType?: string
  locationTypes?: string[]
  instructions?: string
  city?: string
  state?: string
  zipCode?: string
  country: CountryIso2
  latitude?: number
  longitude?: number
  energyCost: number
  groupUid: Uuid
  organizationId: string
  chargers?: Array<{ id: number, uid: string, name: string }>
}

// A location without an address has no coordinates and cannot be placed on the map
export const hasCoordinates = (location: Pick<Location, 'latitude' | 'longitude'>): boolean =>
  Boolean(location.latitude && location.longitude)
